<template>

	<div class="box-sendfile text-center d-flex align-items-center justify-content-center cursor-pointer" @click.prevent="$emit('mediaclick');" :type="type">
	  <div class="w-100">
	    <i class="fal fa-upload w-100"></i>
	    <p class="w-100">Enviar arquivo</p>
	  </div>
	</div>
</template>

<script>
    export default {
        name: "FileAdd",
        data() {
            return {
                cropper: {}
            }
        },
        props: {
            src: String,
            type: String
        },
        mounted() { }
    }
</script>

<style scoped>
	.box-sendfile{
		background: #f7f7f7; color: #CECECE; 
	}
	@media (min-width: 768px){
		.box-sendfile[type="big"]{
			width: 100%; 
			height: 100%;
			min-height: 150px;
		}
	}
	@media (max-width: 767px){
		.box-sendfile[type="big"]{
			width: 100%; 
			height: 100%;
			min-height: 70px;
		}
	}
	.box-sendfile[type="icon"]{
		width: 40px;
	    height: 40px;
	    padding: 10px;
	    border-radius: 50%;
	    position: absolute;
	    bottom: 0;
	    right: 10px;
	}
	.box-sendfile[type="icon"] p{
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/molecules/FileAdd.vue